import React from 'react';
import PropTypes from 'prop-types';
import JoditEditor from 'jodit-react';
import {ErrorMessage, Field, Form, Formik} from 'formik';
/* Components */
import Input from '../../../common/form-elements/input/input';
import {
  maxLength,
  minLength,
  required,
  schemaValidate,
} from '../../../../helpers/validation-helpers';
import FormErrorMessage from '../../../common/form-elements/form-error-message/form-error-message';

class BulletinForm extends React.PureComponent {
  componentWillUnmount() {
    while (document.getElementsByClassName('jodit_fullsize-box_true').length > 0) {
      document
        .getElementsByClassName('jodit_fullsize-box_true')
        .item(0)
        .classList.remove('jodit_fullsize-box_true');
    }
  }

  render() {
    return (
      <Formik initialValues={this.props.initialValues} onSubmit={this.props.onFormSubmit}>
        {(props) => {
          return (
            <Form>
              <div className="glu-modal__body">
                <div className="glu-content__section">
                  <div className="glu-form-row">
                    <div className="glu-label">Widget Title</div>
                    <Field
                      as={Input}
                      autoFocus
                      name="title"
                      className="glu-form-input-pad"
                      onChange={props.handleChange('title')}
                      validate={schemaValidate([required(), minLength(), maxLength(30)])}
                      invalid={props.errors.title && props.touched.title}
                    />
                    <ErrorMessage name="title" component={FormErrorMessage} />
                  </div>
                </div>
                <div className="glu-content__section">
                  <div className="glu-form-row">
                    <div className="glu-label">Insert text, links and images here</div>
                    <div
                      className="
                                                        glu-dashboard-card__text-editor
                                                        glu-form-input-pad"
                    >
                      <JoditEditor
                        ref={this.props.innerRef}
                        value={this.props.initialValues.config.data}
                        config={{
                          readonly: false,
                          height: 300,
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <footer className="glu-modal__footer">
                <div className="glu-flex-grow glu-flex-row">
                  <div className="glu-flex-grow text-right">
                    <button
                      onClick={this.props.onCancel}
                      className="glu-btn glu-btn--secondary"
                      type="button"
                    >
                      Cancel
                    </button>
                  </div>
                  <div className="glu-flex-shrink">
                    <button className="glu-btn glu-btn--primary" type="submit">
                      Save
                    </button>
                  </div>
                </div>
              </footer>
            </Form>
          );
        }}
      </Formik>
    );
  }
}

BulletinForm.propTypes = {
  initialValues: PropTypes.objectOf(PropTypes.any).isRequired,
  onFormSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default React.forwardRef((props, ref) => <BulletinForm innerRef={ref} {...props} />);
